export default __webpack_public_path__ + "static/media/35.02ab4c29.gif";